import { Injectable } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

import { Store } from '@ngrx/store';

import { I18nService } from '@recruitee/i18n';
import {
  LocationsActionsService,
  AssignLocationsFacade,
  LocationsHelperService,
} from '@recruitee/locations';
import { DialogService } from '@recruitee/user-interface';

import { RequisitionFormManagerService } from '../../services/requisition-form-manager.service';

@Injectable()
export class AssignLocationsRequisitionFacade extends AssignLocationsFacade {
  public validateLocations: undefined;
  public getNewLocationOptions: undefined;

  constructor(
    public store: Store,
    public dialogService: DialogService,
    public i18n: I18nService,
    public locationsActionsService: LocationsActionsService,
    public locationsHelper: LocationsHelperService,
    private requisitionFormManager: RequisitionFormManagerService,
  ) {
    super(store, dialogService, i18n, locationsActionsService, locationsHelper);
  }
  public get locationsControl() {
    return <FormArray<FormControl>>this.requisitionFormManager.form.controls.locationIds!;
  }
}
